/**
 * CompanyAdded.contract.ts — Event Contract System™ (generation v1).
 * DOMAIN INTEGRATION HARDENING sprint: a CRM company record was created
 * through the Career Domain Service.
 */

import type { EventContract } from '../EventContractRegistry';

export const CompanyAddedContract: EventContract = {
  name: 'CompanyAdded',
  version: 1,
  description: 'A CRM company record was created via Career™ (API server is the persistence owner).',
  publishers: ['career-domain'],
  subscribers: ['companies-page'],
  fields: [
    { name: 'companyId', type: 'number', required: true, description: 'API-assigned company id' },
    { name: 'name', type: 'string', required: true, description: 'Company name as entered' },
  ],
  allowExtraFields: true,
  timestampPolicy: 'Publish time (Date.now()) after the API create succeeds.',
  stability: 'stable',
  deprecated: false,
  example: { companyId: 7, name: 'Outlier' },
};
